import { render, staticRenderFns } from "./base-datatable.vue?vue&type=template&id=ba1eea36&"
import script from "./base-datatable.vue?vue&type=script&lang=js&"
export * from "./base-datatable.vue?vue&type=script&lang=js&"
import style0 from "./base-datatable.vue?vue&type=style&index=0&id=ba1eea36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports